module.exports = __webpack_public_path__ + "img/pdf-icon.5f1e9a1f.png";